<template>
  <screen-locker>
    <template v-slot:content>
      <div class="page page-areas d-flex flex-column">
        <AppHeader :step-active="2"></AppHeader>
        <div class="row header-page">
          <div class="col">
            <h3>
              I 5 portafogli d’investimento sostenibile che affiancano la
              solidità di GESAV
            </h3>
            <div class="row h-100">
              <div class="col h-100">
                <div class="banner banner-area h-100">
                  <div class="position-absolute">
                    <b-button class="mt-3 btn-red" @click="showModal()"
                      >Scopri di più</b-button
                    >
                  </div>
                  <div
                    class="svg-banner-area w-100 h-100 d-flex align-items-center"
                    v-bind:class="getBannerClasses()"
                  >
                    <svg-viewer
                      :static-call="true"
                      :src="getBannerImage()"
                      :height="window.width <= 1440 ? '350px' : '430px'"
                      width="100%"
                    ></svg-viewer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row form-data mt-3">
          <div class="col mt-3">
            <div class="d-flex">
              <area-selector
                v-for="(item, index) in areaList"
                :key="index"
                :area-id="item.id"
                :title="item.title"
                :sdg-list="item.sdg"
                v-model="item.selected"
              ></area-selector>
            </div>
          </div>
        </div>
        <div class="d-flex footer-page">
          <b-button variant="link" @click="back()">
            <img alt="Indietro" src="../assets/images/back.svg" />
            Indietro
          </b-button>
          <b-button
            variant="primary ml-auto"
            :disabled="disabledNextStep()"
            @click="processData()"
            >Avanti</b-button
          >
        </div>
      </div>
      <b-modal
        v-model="modal"
        adaptive="true"
        title="title"
        dialog-class="modal-full"
        hide-footer
      >
        <template v-slot:modal-header>
          &nbsp;
          <b-button
            variant="link modal-close"
            size="sm"
            class="float-right"
            @click="modal = false"
          >
            <img src="../assets/images/close.svg" alt="Chiudi" />
          </b-button>
        </template>
        <b-container style="height: 80vh">
          <areas-info :area-list="getCurretAreaList()" />
        </b-container>
      </b-modal>
    </template>
    <auth-guard />
  </screen-locker>
</template>

<script>
import router from "../router";
import AreaSelector from "../components/AreaSelector";

import AreasInfo from "./modals/AreasInfo";
import { getAreaListData } from "../data/area-list.data";
export default {
  name: "Areas",
  components: { AreasInfo, AreaSelector },
  data: () => {
    return {
      val: false,
      modal: false,
      areaList: [],
      window: {
        width: 0,
        height: 0
      }
    };
  },
  created() {
    this.areaList = JSON.parse(
      JSON.stringify(getAreaListData(this.$store.state.areaValue))
    );
    if (this.$store.state.areaValue.length !== 0) {
      this.areaList.filter(a => {
        if (this.$store.state.areaValue.filter(v => v.id === a.id).length > 0) {
          a.selected = true;
          a.value = this.$store.state.areaValue.filter(
            v => v.id === a.id
          )[0].value;
        } else {
          a.selected = false;
          a.value = 0;
        }
        return true;
      });
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    disabledNextStep() {
      return this.areaList.filter(a => a.selected).length === 0;
    },
    processData() {
      if (!this.disabledNextStep()) {
        this.saveState();
        router.push("/contributions");
      }
    },
    saveState() {
      let checkSum = 0;
      const updated = this.areaList
        .filter(a => a.selected)
        .map(a => {
          const val = Math.round(
            parseInt(this.$store.state.capitalValue) /
              (this.areaList.filter(a => a.selected).length * 2)
          );
          checkSum += val;
          return {
            id: a.id,
            value: val
          };
        });
      // console.log("checkSum", checkSum);
      if (
        updated.length > 0 &&
        this.$store.state.capitalValue - checkSum !== 0
      ) {
        updated[updated.length - 1].value =
          updated[updated.length - 1].value +
          parseInt(this.$store.state.capitalValue) / 2 -
          checkSum;
      }
      this.$store.commit("setAreaValue", updated);
    },
    back() {
      router.push("/user-data");
    },
    showModal() {
      this.modal = true;
    },
    getBannerClasses() {
      const result = [];
      let className = "";

      const selected = this.areaList
        .filter(a => a.selected)
        .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
      className = `svg-area-${
        selected.length > 0 ? selected.map(a => a.svgClass).join("") : "none"
      }`;

      result.push(className);
      return result;
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    getCurretAreaList() {
      return JSON.parse(
        JSON.stringify(getAreaListData(this.$store.state.areaValue))
      );
    },
    getBannerImage() {
      const selected = this.areaList
        .filter(a => a.selected)
        .sort((a, b) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0));
      const dir = this.window.width <= 1440 ? "main" : "wide";
      const imgName =
        selected.length > 0 ? selected.map(a => a.svgClass).join("") : "Z";
      const path = `./images/banner/02/${dir}/${imgName}.svg`;
      return path;
    }
  }
};
</script>
